export default "__VITE_ASSET__DQ8r7R6Q__"